import { Component, OnInit,Input} from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingState } from '../../loading/loading.component';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';
import {PerExecutionService} from '../../../services/per-execution.service';
import { SettingService} from '../../../services/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-office-computer-inner-tab',
  templateUrl: './office-computer-inner-tab.component.html',
  styleUrls: ['./office-computer-inner-tab.component.scss']
})
export class OfficeComputerInnerTabComponent implements OnInit {
  @Input() projectId:number; 
  form: FormGroup;
  loading: LoadingState = LoadingState.NotReady;
  computerDocumentList:any = [];
  computerDetail:any = [];

  @Input() approveStatus:any = [];
  dialogRef: MatDialogRef<ConfirmDialogComponent>;

  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private perExecutionService:PerExecutionService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public settingService:SettingService
  ) { }

  ngOnInit() {
   

    this.form = this.formBuilder.group({
      project:[this.projectId],
     
      computer_type:[null,Validators.required],
      brand:[null,Validators.required],
      quantity:[null,Validators.required],
      rate:[null,Validators.required],
      supplier_name:[null,Validators.required],
      supplier_ph_no:[null,Validators.required],
      supplier_address:[null,Validators.required],
      latitude:[null],
      longitude:[null],
      requirment_s_date:[null,Validators.required],
      requirment_e_date:[null,Validators.required],
      budgeted_cost:[null,Validators.required],
      executed_cost:[null,Validators.required],
      documents:this.formBuilder.array([
        // this.createDocument()
      ])
    })

    if(this.projectId){
      this.getComputerDetails();
    }
  }


  save(){
    if(this.form.valid){
      var computer_documents_data = [];
      computer_documents_data = this.form.value.documents;
      
      this.loading = LoadingState.Processing

      const data = {
        project: this.projectId,
        
        computer_type:this.form.value.computer_type,
        brand: this.form.value.brand,
        quantity: this.form.value.quantity,
        rate: this.form.value.rate,
        supplier_name: this.form.value.supplier_name,
        supplier_ph_no: this.form.value.supplier_ph_no,
        supplier_address: this.form.value.supplier_address,
        latitude: this.form.value.latitude,
        longitude: this.form.value.longitude,
        requirment_s_date: this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
        requirment_e_date: this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
        budgeted_cost: this.form.value.budgeted_cost,
        executed_cost: this.form.value.executed_cost,
      }
      this.computerDocumentList = [];

      this.perExecutionService.addComputerOffice(data).subscribe(
        res => {
          var forkArray = [];

          computer_documents_data.forEach(x => {
              const formData: any = new FormData();
              formData.append("project",this.projectId);
              formData.append("module_id", res.id);
              formData.append("document_name", x.document_name);
              formData.append("document", x.computer_document, x.computer_document['name']);
              forkArray.push(this.perExecutionService.addComputerDocumentOffice(formData))
          })
          forkJoin(forkArray).subscribe(
            (result: any[]) => {
              // console.log(result)
              result.forEach(y => {
                this.computerDocumentList.push(y)
              })
              
              // this.add_tender_document()
              this.loading = LoadingState.Ready;
            },
            err => {
              this.loading = LoadingState.Ready;
              // console.log(err)
            }
          )
          this.loading = LoadingState.Ready;
          this.getComputerDetails();
          this.toastr.success('Data has been saved','',{
            timeOut: 3000,
          });
        },
        error=>{
          //console.log(error);
          this.loading = LoadingState.Ready;
          this.toastr.error('Something went wrong', '', {
            timeOut: 3000,
          });
        }
      )



    }else{
      this.markFormGroupTouched(this.form);
    }
  }

  update(){
    if(this.form.valid){
      this.loading = LoadingState.Processing
      var computer_documents_data = [];
      computer_documents_data = this.form.value.documents;

      if(this.form.value.documents.length > 0){
        var forkArray = [];
        computer_documents_data.forEach(x => {
            const formData: any = new FormData();
            formData.append("project", this.projectId);
            formData.append("module_id", this.computerDetail.id);
            formData.append("document_name", x.document_name);
            formData.append("document", x.computer_document, x.computer_document['name']);
            forkArray.push(this.perExecutionService.addComputerDocumentOffice(formData))
        })
        forkJoin(forkArray).subscribe(
          result => {
            // console.log(result)
            result.forEach(y => {
              this.computerDocumentList.push(y)
            })
           
            // this.add_tender_document();
            this.loading = LoadingState.Ready;
          },
          err => {
            this.loading = LoadingState.Ready;
            // console.log(err)
          }
        )
        this.updateComputer();
      }

      else{
        this.updateComputer();
      }
    }else{
      this.markFormGroupTouched(this.form);
    }
  }

  updateComputer(){
    if(this.form.valid){
      const updateData = {
        project: this.projectId,
       
        computer_type:this.form.value.computer_type,
        brand: this.form.value.brand,
        quantity: this.form.value.quantity,
        rate: this.form.value.rate,
        supplier_name: this.form.value.supplier_name,
        supplier_ph_no: this.form.value.supplier_ph_no,
        supplier_address: this.form.value.supplier_address,
        latitude: this.form.value.latitude,
        longitude: this.form.value.longitude,
        requirment_s_date: this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
        requirment_e_date: this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
        budgeted_cost: this.form.value.budgeted_cost,
        executed_cost: this.form.value.executed_cost,
      }
      this.perExecutionService.editComputerOffice(this.computerDetail.id,updateData).subscribe(
        res =>{
          //console.log(res)
          this.loading = LoadingState.Ready;
          this.toastr.success('Data has been saved','',{
            timeOut: 3000,
          });
        },
        error =>{
         // console.log(error)
          this.loading = LoadingState.Ready;  
          this.toastr.error('Something went wrong', '', {
            timeOut: 3000,
          });
        }
      )
    }else{
      this.markFormGroupTouched(this.form);
    }
  }

  getComputerDetails(){
    this.perExecutionService.getComputerOffice(this.projectId).subscribe(
      res=>{
        if(res['result'][0]){
          this.computerDetail = res['result'][0];
          //console.log(this.computerDetail);
          this.computerDocumentList = res['result'][0].document_details;
          var start_date = new Date(this.computerDetail['requirment_s_date'])
            this.computerDetail.requirment_s_date = {
              year: start_date.getFullYear(),
              month: start_date.getMonth()+1,
              day: start_date.getDate()
        
            }
            var end_date = new Date(this.computerDetail['requirment_e_date'])
            this.computerDetail.requirment_e_date = {
              year: end_date.getFullYear(),
              month: end_date.getMonth()+1,
              day: end_date.getDate()
              
            }
          this.form.patchValue({
            latitude: this.computerDetail.latitude,
            longitude: this.computerDetail.longitude
          })
          this.computerDetail.rate = parseFloat(this.computerDetail.rate).toFixed(2);
          this.computerDetail.budgeted_cost = parseFloat(this.computerDetail.budgeted_cost).toFixed(2);
          this.computerDetail.executed_cost = parseFloat(this.computerDetail.executed_cost).toFixed(2);
        }
        this.loading = LoadingState.Ready;
      },
      error => {
       // console.log(error);
        this.loading = LoadingState.Ready;
        this.toastr.error('Something went wrong', '', {
          timeOut: 3000,
        });
      }
    )
  }

  getFile(file: string) {
    var fileName = file.split('.')
    var fileExt = fileName[fileName.length - 1];
    if (fileExt == 'jpg' || fileExt == 'jpeg' || fileExt == 'png') {
      return file;
    }
    else {
      return 'assets/img/pdf.png'
    }
  }

  editDoc(index) {
    this.computerDocumentList[index]['isEdit'] = true
    this.computerDocumentList[index]['isFieldError'] = false
  }

  renameDoc(index) {
    if (this.computerDocumentList[index]['document_name'] == '') {
      this.computerDocumentList[index]['isFieldError'] = true;
    }
    else {
      this.loading = LoadingState.Processing
      this.computerDocumentList[index]['isFieldError'] = false;
      var data = {
        document_name: this.computerDocumentList[index]['document_name']
      }

      
      this.perExecutionService.editComputerDocumentOffice(this.computerDocumentList[index]['id'], data).subscribe(
        res => {
          // console.log(res)
          this.computerDocumentList[index]['isEdit'] = false
          this.loading = LoadingState.Ready
        },
        error => {
          // console.log(error)
          this.loading = LoadingState.Ready
        }
      )
    }
  }
  
  viewDoc(documentData){
    window.open(documentData.document,documentData.document_name,'height=700,width=800,scrollbars=yes');
  }


  deleteDoc(index) {
    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: false
    });

    this.dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete?"

    this.dialogRef.afterClosed().subscribe(result => {
     if(result){
      this.loading = LoadingState.Processing
      this.perExecutionService.deleteComputerDocumentOffice(this.computerDocumentList[index]['id']).subscribe(
        res => {
          this.computerDocumentList.splice(index, 1)
          // console.log(res)
          this.loading = LoadingState.Ready
        },
        error => {
          // console.log(error)
          this.loading = LoadingState.Ready
        }
      )
	 }
	 this.dialogRef = null;
	 })

   
  }

  handleAddressChange(address) {
    // Do some stuff
    //console.log(address)
    var lat = address.geometry.location.lat();
    var lng = address.geometry.location.lng();
    var formattedAddress = address.formatted_address
    
    this.form.patchValue({
      latitude: lat,
      longitude: lng,
      supplier_address: formattedAddress
    })
  }

  createDocument(){
    return this.formBuilder.group({
      document_name: [null, Validators.required],
      document: [null, Validators.required],
      computer_document: null
    })
  }

  getFormArrayControl(form) {
    return form.get('documents').controls
  }

  addDocument()
  {
    const control = <FormArray>this.form.controls['documents'];
    control.push(this.createDocument());
  }

  deleteDocument(index:number)
  {
    const control = <FormArray>this.form.controls['documents'];
    control.removeAt(index);
  }


  onSelectFile(event, index){
    //console.log(event.target.files);
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event) => {
          // console.log(event.target['result']);
        }
        const control = <FormArray>this.form.controls['documents'];
        control.at(index).patchValue({
          document: event.target.files[0]['name'],
          computer_document: event.target.files[0]
        })
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }



}
